// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"51b2ac23","239":"28e429d6","453":"7fb3ca74","455":"221cf323"}[chunkId] + ".chunk.js";
};